/*
	Products store

	main recipient of Products data from Shopify
*/

// Libs
import Vue from 'vue'

// Components
export { Product as ProductsStore } from '../models/product'




// WEBPACK FOOTER //
// ./src/core/stores/products-store.js